export const ROUTES = {
    HOME: "/",
    LOGIN: "/login",
    REGISTER: "/register",
    OTP_VERIFY: "/OtpVerify",
    FORGOT_PASSWORD: "/Forget",
    AboutUs: "/about",
    Contact: "/Contact",
    Fordentist: "/Fordentist",
    Forlabs:"/Forlabs",
    Bookdemo:"/Bookdemo",
    Findadendtist:"/Findadendtist",
    Faq:"/Faq",
    Blogcomingsoon:"/Blogcomingsoon",
    Termsandconditions:"/Termsandconditions",
    RefundPolicy:"/RefundPolicy",
    PrivacyPolicy:"/PrivacyPolicy",
    RazorpayTest:"/RazorpayTest",

    SEARCH_DENTIST: "/search-dentist",
    INVALID: "*",
    PageNotCreated: "#",
    CENTRAL: {
        ChangePassword: "/ChangePassword",
        ADD_RESTORATION: "/central/AddRestoration",
        ADD_MATERIAL: "/central/AddMaterial",
        ADD_SHADE: "/central/AddShade",
        ADD_REJECTION_REASON: "/central/AddRejectionReason",
        CANCELLATION_REASON: "/central/CancellationReason",
        ADD_ORDER_TYPE: "/central/AddOrderType",
        RatingAnalytics: "/central/RatingAnalytics",
        Ratingadvanceinfo: "/central/Ratingadvanceinfo",
        RatingAnalyticsTabs: "/central/RatingAnalyticsTabs",
        InternalPerformanceRating: "/central/InternalPerformanceRating",
        ADD_USERS: "/central/AddUsers",
        ADD_GENERATECOUPON: "/central/GenerateCoupon",
        USER_LOGIN_HISTORY: "/central/UserLoginHistory",
        CENTRAL_HUB_DASHBOARD: "/central/dashboard",
        CENTRAL_HUB_DashboardAdminCentralHub: "/central/Admin/DashboardAdminCentralHub",
        CENTRAL_DesignerDasboard: "/central/DesignerDasboard",
        TicketType: "/central/TicketType",
        CENTRAL_DesignerCards: "/central/DesignerCards",
        CENTRAL_DesignerChart: "/central/DesignerChart",
        CENTRAL_PaymentTracking: "/central/PaymentTracking",
        CENTRAL_PaymentInvoices: "/central/PaymentInvoices",
        CENTRAL_InvoicePrintout: "/central/InvoicePrintout",
        CENTRAL_DesignerLeaderboard: "/central/DesignerLeaderboard",
        CENTRAL_DesignerHeatmap: "/central/DesignerHeatmap",
        CENTRAL_DesignerTable: "/central/DesignerTable",
        CENTRAL_MillingPerformance: "/central/MillingPerformance",
        AdminContactSupport: "/central/AdminContactSupport",
        CENTRAL_PROFILE: "/central/profile",
        CENTRAL_Phasewisededuction: "/central/Phasewisededuction",
        CENTER_APPROVALS: "/Central/Approvals",
        REPORT_DELAY: "/central-hub/report-delay",
        FINISHED_ORDERS: "/central-hub/finished-orders",
        CENTRAL_NotificationDetail: "/central/notification-detail/:id",
        CENTRAL_HUB_GUARANTEECARD: "/central/guarantee-card",
        CENTRAL_HUB_ORDERTAGDETAILS: "/central/OrderTagDetails",
        CENTRAL_HUB_CHECKBOXMASTER: "/central/CheckBoxMaster",
        CENTRAL_HUB_ADDSLA: "/central/AddSLA",
        CENTRAL_Adminstlpreview: "/central/Adminstlpreview",
        CENTRAL_AdminstlpreviewNew: "/central/AdminstlpreviewNew",
        CENTRAL_CancelOrder: "/central/CancelOrderAdmin",
        CENTRAL_ApproveRejectCancelOrder:"/central/CancellationManagement",
        CENTRAL_AdminDeliveryPartner: "/central/AdminDeliveryPartner",
        CENTRAL_AddDeliverypartner: "/central/AddDeliverypartner",
        CENTRAL_CompleteOrder: "/central/CompleteOrder",
        CENTRAL_DentistMillinglist: "/central/DentistMillinglist",
        CENTRAL_AdminReport: "/central/AdminReport",
        CENTRAL_DesignerPerformance: "/central/DesignerPerformance",
        CENTRAL_MillingResourceOverview: "/central/MillingResourceOverview",
        CENTRAL_DispatchOverview: "/central/DispatchOverview",
        AdminRejectedOrder: "/central/AdminRejectedOrder",
        Priority: "/central/Priority",
        ReplyRaiseTicket: "/central/ReplyRaiseTicket",
        WarrantyClaimResponse: "/central/WarrantyClaimResponse",
        OrderSerachPage:"/central/OrderSerachPage",
        SLABreachMonitor:"/central/SLABreachMonitor",
        AdminRealtimeOrderTracking:"/central/AdminRealtimeOrderTracking",
        Manager: {
            MANAGER_DashboardManagerCentralHub: "/manager/DashboardManagerCentralHub",
            MANAGER_ManagerstlPreview: "/manager/ManagerstlPreview",
            MANAGER_CancelOrder: "/manager/CancelOrder",
            MANAGER_ManagerProfile: "/manager/ManagerProfile",
            MANAGER_DeliveryPartner: "/manager/DeliveryPartner",
            ChangePassword: "/manager/ChangePassword",
            CompleteOrder: "/manager/CompleteOrder",
            MANAGER_DentistMillinglist: "/manager/ManagerDentistMillingList",
            MANAGER_ManagerReport: "/manager/ManagerReport",
            MANAGER_ManagerDesignerPerformance: "/manager/ManagerDesignerPerformance",
            MANAGER_ManagerDispatchOverview: "/manager/ManagerDispatchOverview",
            MANAGER_ManagerMillingPerformance: "/manager/ManagerMillingPerformance",
            MANAGER_ManagerMillingResourceOverview: "/manager/ManagerMillingResourceOverview",
            ManagerRejectedOrder: "/manager/ManagerRejectedOrder",
            ManagerTicket: "/manager/ReplyRaiseTicket",
            ManagerSLABreachMonitor:"/manager/ManagerSLABreachMonitor",
            ManagerContactSupport:"/manager/ManagerContactSupport",
            RealtimeOrderTracking:"/manager/RealtimeOrderTracking",
            ManagerWarrantyClaimResponse:"/manager/ManagerWarrantyClaimResponse",

        },
        Designer: {
            DESIGNER_DASHBOARD: "/designer/dashboard",
            ChangePassword: "/designer/ChangePassword",
            DESIGNER_PROFILE: "/designer/DesignerProfile",
            DesignerReport: "/designer/DesignerReport",
            DesignerCompleteOrders: "/designer/DesignerCompleteOrders",
            Settings: {
                officetimings: "/designer/OfficeTimings",
            }
        }
    },

    DENTIST: {
        DENTIST_DASHBOARD: "/dentist/dashboard",
        DENTIST_DASHBOARD_EDIT_DRAFT: "/dentist/dashboard/:draftId",
        CLINIC_DETAILS: "/dentist/clinicdetails",
        DENTIST_PROFILE: "/dentist/profile",
        DENTIST_DRAFT_LIST: "/dentist/drafts",
        DENTIST_DRAFT_DETAILS: "/dentist/draft/:draftId",
        DENTIST_DENTISTDETAILS: "/dentist/DentistDetails",
        DENTIST_SETTINGS: "/dentist/Settings",
        DENTIST_REUPLOADSCAN: "/dentist/ReuploadScan",
        DENTIST_REUPLOADADDSCAN: "/dentist/ReuploadAddScan",
        DENTIST_REUPLOADADDSCANUNDERREVIEW: "/dentist/ReuploadAddScanUnderreview",
        ChangePassword: "/dentist/ChangePassword",
        RaiseTicket: "/dentist/RaiseTicket",
        CompleteOrder: "/dentist/CompleteOrder",
        DENTIST_CancelOrder: "/dentist/DentistCancelOrder",
        DENTIST_Report: "/dentist/DentistReport",
        ContactSupport: "/dentist/ContactSupport",
        DentistContactSupport:"/dentist/DentistContactSupport",
        PaymentRetryPage: "/dentist/PaymentRetryPage",
    },

    MILLING: {
        MILLING_PROFILE: "/milling/profile",
        MILLING_HUB_DASHBOARD: "/milling/dashboard",
        MILLING_OrdersPayment: "#",
        MILLING_NotificationDetail: "/milling/notification-detail/:id",
        MILLING_AddMachine: "/milling/AddMachine",
        MILLING_Report: "/milling/MillingReport",
        ChangePassword: "/milling/ChangePassword",
        MillingCompleteOrder: "/milling/MillingCompleteOrder",
        Settings: {
            officetimings: "/milling/OfficeTimings",
        }
    },

    DELIVERYPARTNER: {
        DELIVERYPARTNER_DELIVERYPARTNERDASHBOARD: "/Deliverypartner/DeliverypartnerDashboard",
        DELIVERYPARTNER_DeliveryPartnerReport: "/Deliverypartner/DeliveryPartnerReport",
        DELIVERYPARTNER_ChangePassword: "/Deliverypartner/ChangePassword",
        DeliverySchedule: "/Deliverypartner/OfficeTimings",
        DELIVERYPARTNER_DeliverypartnerProfile: "/Deliverypartner/DeliverypartnerProfile",
    }

   
};
